import { createElement as e, Component as t } from "react";

function n(e, t) {
  for (var n = 0; n < t.length; n++) {
    var i = t[n];
    i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(e, i.key, i);
  }
}

function i(e, t, n) {
  return t in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}

function r(e, t) {
  var n = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    t && (i = i.filter(function (t) {
      return Object.getOwnPropertyDescriptor(e, t).enumerable;
    })), n.push.apply(n, i);
  }

  return n;
}

function o(e) {
  return (o = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
    return e.__proto__ || Object.getPrototypeOf(e);
  })(e);
}

function s(e, t) {
  return (s = Object.setPrototypeOf || function (e, t) {
    return e.__proto__ = t, e;
  })(e, t);
}

function l(e, t) {
  if (null == e) return {};

  var n,
      i,
      r = function (e, t) {
    if (null == e) return {};
    var n,
        i,
        r = {},
        o = Object.keys(e);

    for (i = 0; i < o.length; i++) {
      n = o[i], t.indexOf(n) >= 0 || (r[n] = e[n]);
    }

    return r;
  }(e, t);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);

    for (i = 0; i < o.length; i++) {
      n = o[i], t.indexOf(n) >= 0 || Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
    }
  }

  return r;
}

function c(e, t) {
  return !t || "object" != typeof t && "function" != typeof t ? function (e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
  }(e) : t;
}

var u = function (u) {
  function a(e) {
    var t;
    return function (e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }(this, a), (t = c(this, o(a).call(this, e))).state = {
      noClamp: !1,
      text: "."
    }, t.element = null, t.original = e.text, t.lineHeight = 0, t.start = 0, t.middle = 0, t.end = 0, t.debounced = t.debounce(t.action), t;
  }

  var f, p, h;
  return function (e, t) {
    if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
    e.prototype = Object.create(t && t.prototype, {
      constructor: {
        value: e,
        writable: !0,
        configurable: !0
      }
    }), t && s(e, t);
  }(a, t), f = a, (p = [{
    key: "componentDidMount",
    value: function value() {
      window.addEventListener("resize", this.debounced), this.props.text && (this.lineHeight = this.element.clientHeight + 1, this.clampLines());
    }
  }, {
    key: "componentWillUnmount",
    value: function value() {
      window.removeEventListener("resize", this.debounced);
    }
  }, {
    key: "debounce",
    value: function value(e) {
      var t,
          n = this,
          i = function i() {
        t = null, e.apply(n);
      };

      return function () {
        var r = !t;
        clearTimeout(t), t = setTimeout(i, n.props.debounce), r && e.apply(n);
      };
    }
  }, {
    key: "action",
    value: function value() {
      this.original && this.setState({
        noClamp: !1
      }, this.clampLines);
    }
  }, {
    key: "clampLines",
    value: function value() {
      var e = this,
          t = this.props,
          n = t.ellipsis,
          i = t.lines,
          r = this.lineHeight * i + 1,
          o = n === a.defaultProps.ellipsis ? 5 : 1.2 * n.length;

      for (this.start = 0, this.middle = 0, this.end = this.original.length; this.start <= this.end;) {
        if (this.middle = Math.floor((this.start + this.end) / 2), this.element.innerText = this.original.slice(0, this.middle), this.middle === this.original.length) return void this.setState({
          text: this.original,
          noClamp: !0
        });
        this.moveMarkers(r);
      }

      var s = this.original.slice(0, Math.max(this.middle - o, 0)).trim() + n;
      this.setState({
        text: s
      }, function () {
        e.element.innerText = e.state.text;
      });
    }
  }, {
    key: "moveMarkers",
    value: function value(e) {
      this.element.clientHeight <= e ? this.start = this.middle + 1 : this.end = this.middle - 1;
    }
  }, {
    key: "render",
    value: function value() {
      var t = this,
          n = this.state.text,
          o = this.props,
          s = o.accessibility,
          c = o.is,
          u = o.text,
          a = (o.lines, o.debounce, o.ellipsis, function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var n = null != arguments[t] ? arguments[t] : {};
          t % 2 ? r(Object(n), !0).forEach(function (t) {
            i(e, t, n[t]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : r(Object(n)).forEach(function (t) {
            Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
          });
        }

        return e;
      }({
        ref: function ref(e) {
          return t.element = e;
        }
      }, s ? {
        title: u
      } : {}, {}, l(o, ["accessibility", "is", "text", "lines", "debounce", "ellipsis"])));
      return u ? e(c, a, n) : null;
    }
  }]) && n(f.prototype, p), h && n(f, h), a;
}();

u.defaultProps = {
  accessibility: !0,
  is: "div",
  lines: 3,
  ellipsis: "…",
  debounce: 300
};
export default u;